import { connect } from 'react-redux'
import AssessementInvitationModal from './assessment-invitation-modal'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getAssessmentFileId } from './assessement-invitation.selectors'
import {
  closeInvitationAssessmentDialog,
  inviteToAssessmentFile
} from '../../../../../stores/assessment/assessment.actions'
import { isOpen } from './assessement-invitation.selectors'
import { toast } from 'pobble-components/dist/toast'

const mapStateToProps = state => {
  return {
    isOpen: isOpen(state),
    id: getAssessmentFileId(state)
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  requestClose: () => dispatch(closeInvitationAssessmentDialog()),
  onSubmit: (emails, token) =>
    dispatch(
      inviteToAssessmentFile(
        stateProps.id,
        emails.map(email => email.value),
        token
      )
    )
      .then(resp => {
        toast.success('Your invitation was sent.')
        return dispatch(closeInvitationAssessmentDialog())
      })
      .catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(AssessementInvitationModal)
